import React, {Component, useRef} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Link, Redirect, Route } from 'react-router-dom';
import HeaderSample from "../common/headerSample";
import Button from 'react-bootstrap/Button';
import { URL,USER } from "../../constants/constant";
import _axios from 'axios'

class PhleboProfile extends Component{
  constructor(props){
    super(props);
    this.state = {
        userdata : USER.user,
    }

  }
  render(){

    return(
        <div>
            <div className="order-details-dashboard">
                <div>
                   <HeaderSample titleCall={true} noCall={true} title="Profile"></HeaderSample> 
                </div>
                <div>
                    <Container className="p-t-10 p-b-10">
                    </Container>
                    <Container className="p-b-10">
                        <Row>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    Name
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.name}
                                </div>
                            </Col>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    Date of Birth
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.dob}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className="p-t-10 p-b-10">
                        <Row>
                            <Col xs={12} md={12}>
                                <div className="font-size-sm">
                                    ADDRESS
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className="p-b-10">
                        <Row>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    Address Line 1
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.addressline1}
                                </div>
                            </Col>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    Address Line 2
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.addressline2}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className="p-b-10">
                        <Row>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    Address Line 3
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.addressline3}
                                </div>
                            </Col>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    City
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.city}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className="p-b-10">
                        <Row>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    State
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.state}
                                </div>
                            </Col>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    Pincode
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.pincode}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className="p-t-10 p-b-10">
                        <Row>
                            <Col xs={12} md={12}>
                                <div className="font-size-sm">
                                    CONTACT DETAILS
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className="p-b-10">
                        <Row>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    Phone Number 1
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.phonenumber1}
                                </div>
                            </Col>
                            <Col xs={6} md={6}>
                                <div className="font-size-sm">
                                    Phone Number 2
                                </div>
                                <div className="font-size-smd bold">
                                    {this.state.userdata.phonenumber2}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
           </div>     
           <Container>
                      <Row>
                          <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
                            <div className="p-b-10">
                                 <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={this.props.history.goBack}>Back</button>
                              </div>
                          </div>
                      </Row>
                  </Container>
        </div>
    )
  }
}
export default PhleboProfile;